import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, prjPatternId} = map.data

    if (! (prjPatternId && 'SA_MAP' === mapTypeCode)) {
        return null
    }

    const onClick = () => openWindow('/WorkloadBd', {prjPatternId})

    return {
        key: 'workflow-by-bd',
        label: '查看程序模块工作量清单',
        onClick,
    }
}
